"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function canonicalizeUri(uri) {
    return uri.replace(/\/+$/, '');
}
/**
 * Specifies the base service URIs used by SDK components.
 */
class ServiceEndpoints {
    constructor(streaming, polling, events = ServiceEndpoints.DEFAULT_EVENTS, analyticsEventPath = '/bulk', diagnosticEventPath = '/diagnostic', includeAuthorizationHeader = true) {
        this.streaming = canonicalizeUri(streaming);
        this.polling = canonicalizeUri(polling);
        this.events = canonicalizeUri(events);
        this.analyticsEventPath = analyticsEventPath;
        this.diagnosticEventPath = diagnosticEventPath;
        this.includeAuthorizationHeader = includeAuthorizationHeader;
    }
}
ServiceEndpoints.DEFAULT_EVENTS = 'https://events.launchdarkly.com';
exports.default = ServiceEndpoints;
//# sourceMappingURL=ServiceEndpoints.js.map